import { render, staticRenderFns } from "./ConfigurationSidepanelTabs.vue?vue&type=template&id=281f6bec&"
import script from "./ConfigurationSidepanelTabs.vue?vue&type=script&lang=js&"
export * from "./ConfigurationSidepanelTabs.vue?vue&type=script&lang=js&"
import style0 from "./ConfigurationSidepanelTabs.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports